import { convertListingTypeToValuesForTracking } from '@/helpers/GTM/GTMHelpers';
import { InteractionEvent, InteractionGoal } from '@/helpers/GTM/GTMParameters';
import { trackEventHarmonized } from '@/helpers/GTM/GTMTrack';
import { getSortedDetails } from '@/resultlist/LayoutSolutionResultListPage.tracking';
import { ListingItem, SearchModel } from '@smg-real-estate/hg-search-libs';

interface HideListingTrackingMeta {
  listingItem: ListingItem;
  positionOverall: number;
  listingCardSize?: string;
  searchModel: SearchModel;
}
export function trackHideListingInteraction(
  trackingMeta: HideListingTrackingMeta,
  action: InteractionGoal,
): void {
  trackEventHarmonized(InteractionEvent.HIDE_LISTING_INTERACTION, {
    h_event_category_006: InteractionEvent.HIDE_LISTING_INTERACTION,
    h_event_action_007: action,
    h_event_label_008: trackingMeta.listingItem.id,
    h_position_on_list_overall_283: trackingMeta.positionOverall,
    h_listing_lister_id_154: trackingMeta.listingItem.listing.lister?.id,
    h_listing_layout_124:
      trackingMeta.listingCardSize ?? trackingMeta.listingItem.listingCard?.size,
    h_search_sorted_details_073: getSortedDetails(
      trackingMeta.searchModel.sortDirection,
      trackingMeta.searchModel.sortType,
    ),
    h_list_item_vas_090: convertListingTypeToValuesForTracking(
      trackingMeta.listingItem.listingType?.type,
    ),
    h_listing_advertisement_id_120: trackingMeta.listingItem.id,
  });
}
